import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';

const DigitContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100%;

  .infoscreen & {
    justify-content: space-between;
  }
`;

const DigitBlock = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  justify-items: center;
  background-color: ${(p) => p.theme.color.countdownBg};
  max-height: 220px;
  align-items: center;
`;

const DigitSubtitle = styled.div`
  grid-column: span 2;
  font-size: 1.6rem;
  font-weight: 600;

  @media (max-width: 999px) {
    font-size: 1.5rem;
  }
  @media (max-width: 799px) {
    font-size: 1.2rem;
  }
  @media (max-width: 639px) {
    font-size: 1rem;
  }
  @media (max-width: 479px) {
    font-size: 0.9rem;
  }
  @media (max-width: 399px) {
    font-size: 0.8rem;
  }

  .infoscreen & {
    font-size: 1.8rem;
  }
`;

const DigitWrapper = styled.div`
  color: #153D5D;
  font-size: 6rem;
  height: 1.0em;
  width: 1.2ch;
  line-height: 1.0em;
  position: relative;
  overflow: hidden;

  @media (max-width: 999px) {
    font-size: 5rem;
  }
  @media (max-width: 799px) {
    font-size: 4rem;
  }
  @media (max-width: 639px) {
    font-size: 3rem;
  }
  @media (max-width: 479px) {
    font-size: 2.4rem;
  }
  @media (max-width: 399px) {
    font-size: 2.1rem;
  }

  .infoscreen & {
    font-size: 10rem;
    width: 1.2ch;
  }
`;

const Digit = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: center;

  &.countdown-enter {
    opacity: 0;
    top: -100%;
  }
  &.countdown-enter-active {
    opacity: 1;
    top: 0;
    transition: opacity 300ms, top 300ms;
  }
  &.countdown-exit {
    opacity: 1;
    top: 0;
  }
  &.countdown-exit-active {
    opacity: 0;
    top: 100%;
    transition: opacity 300ms, top 300ms;
  }
`;

const countdownTo = new Date('2026-04-18T12:00:00+03:00');

const CountdownPage = () => {
  const [showCountdown, setShowCountdown] = useState(Date.now() < countdownTo);
  const { t } = useTranslation();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    let lastTick = Date.now();
    let timer;
    const tick = () => {
      setNow(Date.now());
      // Tick semi-consistently every second
      const nextTick = lastTick + 1000;
      timer = setTimeout(tick, Math.max(0, nextTick - Date.now()));
      lastTick = nextTick;
    };
    timer = setTimeout(tick, 1000);
    return () => clearInterval(timer);
  }, []);


  const totalMs = Math.max(countdownTo - now, 0);
  const sec = Math.floor((totalMs / 1e3) % 60);
  const min = Math.floor((totalMs / 60e3) % 60);
  const hour = Math.floor((totalMs / 3600e3) % 24);
  const day = Math.floor(totalMs / 86400e3);

  useEffect(() => {
    const timer = setInterval(() => setShowCountdown(Date.now() < countdownTo), 5000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => window.location.reload(), 300e3);
    return () => clearTimeout(timer);
  }, []);

  const renderDigit = (digit) => (
    <DigitWrapper>
      <TransitionGroup>
        <CSSTransition key={digit} classNames="countdown" timeout={300}>
          <Digit>{digit}</Digit>
        </CSSTransition>
      </TransitionGroup>
    </DigitWrapper>
  );

  const renderDigits = (number, subtitle) => (
    <DigitBlock>
      {renderDigit(Math.floor(number / 10))}
      {renderDigit(number % 10)}
      <DigitSubtitle>{subtitle}</DigitSubtitle>
    </DigitBlock>
  );

  return (
    <>
      {showCountdown && (
        // 1536x256
        <DigitContainer>
          {renderDigits(day, t('countdown.days'))}
          {renderDigits(hour, t('countdown.hours'))}
          <div style={{ display: 'flex', width: '220px', height: '220px', alignItems: 'center' }}>
            {/* <img alt='logo' style={{ magrinLeft: 'auto', marginRight: 'auto', position: 'absolute', opacity: '0.2', filter: 'invert(1)', height: '180px', width: '180px' }} src='https://static.radiodiodi.fi/img/ajaton/ajaton_logo.png'/> */}
            <img alt='lissu' style={{ magrinLeft: 'auto', marginRight: 'auto', position: 'absolute', height: '180px' }} src='https://static.radiodiodi.fi/img/2026/icons/lissu_ajaton.png'/>
          </div> 
          {renderDigits(min, t('countdown.minutes'))}
          {renderDigits(sec, t('countdown.seconds'))}
      </DigitContainer>
    )}
    </>
  );
}

export default CountdownPage;
